
import { APP_EVENTS } from '@/common/constants'
import eventBus from '@/common/utils/eventBus'
import Vue from 'vue'

export default Vue.extend({
  props: {
    initProductId: {
      type: String,
      required: true
    },
    productGroupIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedProductId: ''
    }
  },
  methods: {
    showDetailModal() {
      eventBus.$emit(APP_EVENTS.SHOW_PRODUCT_QUICK_PREVIEW, this.initProductId, this.productGroupIds)
    }
  }
})
